import { config } from '../config'

import { TableSection } from '@ui/cases/TableSection'

import { Wrapper } from './styles'

const { overview } = config

export function Overview() {
  return (
    <Wrapper>
      <TableSection {...overview} />
    </Wrapper>
  )
}
